module.exports = __webpack_public_path__ + "static/media/microphone-slash-solid.54da012d.svg";